import { useCallback } from 'react';

import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { fetchInGameHistoryData } from '../../store/apiActions/fetchInGameHistoryData';

export const useInGameHistoryDataFetcher = () => {
  const countPerPage = 20;
  const dispatch = useCoreDispatch();
  const tableId = useConfigSlice.tableId();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const gsAddress = useConfigSlice.env()?.report;

  return useCallback(
    (page: number = 1, forceFetch: boolean = false) => {
      if (JSESSIONID && gsAddress && tableId) {
        dispatch(
          fetchInGameHistoryData({
            JSESSIONID,
            tableId,
            rowStart: 0,
            rowEnd: page * countPerPage,
            url: `${gsAddress}/api/ui/history/in-game`,
            force: forceFetch,
          })
        );
      }
    },
    [dispatch, JSESSIONID, gsAddress, tableId]
  );
};
